import { apiFetch } from '../../../lib/apiClient';

export interface CalendarEvent {
  id: number;
  externalEventId: string;
  provider: string;
  title: string | null;
  startTime: string;
  endTime: string;
  status: string;
  organizerEmail: string | null;
  organizerName: string | null;
  hasExternal: boolean | null;
  visibilityClassification: string | null;
  businessClassification: string | null;
  classificationSource: string | null;
  externalDomains: string[] | null;
  internalDomains: string[] | null;
  lastSyncedAt: string | null;
}

export interface CalendarEventsResponse {
  events: CalendarEvent[];
  pagination: { total: number; limit: number; offset: number };
}

export interface CalendarConnectionStatus {
  connected: boolean;
  status: string | null;
  connectedAt: string | null;
}

export const meetingsApi = {
  listEvents(params?: {
    status?: string;
    classification?: string;
    limit?: number;
    offset?: number;
  }): Promise<CalendarEventsResponse> {
    const query = new URLSearchParams();
    if (params?.status) query.set('status', params.status);
    if (params?.classification) query.set('classification', params.classification);
    if (params?.limit != null) query.set('limit', String(params.limit));
    if (params?.offset != null) query.set('offset', String(params.offset));
    const qs = query.toString();
    return apiFetch(`/api/calendar/events${qs ? `?${qs}` : ''}`);
  },

  getConnectionStatus(): Promise<CalendarConnectionStatus> {
    return apiFetch('/api/integration/google-calendar/status');
  },

  getConnectUrl(): Promise<{ url: string }> {
    return apiFetch('/api/integration/google-calendar/connect');
  },

  syncMe(): Promise<void> {
    return apiFetch('/api/calendar/sync/me', { method: 'POST' });
  },
};
